<template>
  <div class="mt-28">
    <div class="flex justify-start md:justify-center w-full mb-6">
			<DoiHeader :level="4" :fontFamily="1" :headerColor="0" class="text-2xl md:text-4xl uppercase tracking-wide">Historique des paiements</DoiHeader>
		</div>
    <div v-if="isLoaded">
      <DoiText v-if="paymentList.paiements.length === 0" :textColor="3" :fontSize="3" class="text-center mx-auto">Vous n'avez effectué aucun paiement pour le moment.</DoiText>
      <template v-else>
        <PaymentHistoryList :paymentList="paymentList.paiements" />
      </template>
    </div>
    <DoiSpinner v-else />
  </div>
</template>

<script>
import PaymentHistoryList from '@/views/reglements/PaymentHistoryList'
import DoiSpinner from '@/components/atomic/DoiSpinner'
import { getHistoryPaymentV2 } from '@/api/PaymentService'

export default {
  name: 'PaymentHistory',
  data () {
    return {
      isLoaded: false,
      paymentList: {}
    }
  },
  components: { DoiSpinner, PaymentHistoryList },
  async mounted () {
    this.isLoaded = false
    await this.getHistoryPayment()
    this.isLoaded = true
  },
  computed: {
    userId() {
      return this.$store.getters["AuthModule/get_userIdV2"]
    }
  },
  methods: {
    async getHistoryPayment () {
      this.paymentList = await getHistoryPaymentV2(this.userId)
    }
  }
}
</script>

<style scoped>
</style>
